import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { default as NextImage } from "next/image";
import { requireStaticImageAtomComponent } from "@vfit/shared/data-access";
import { GradientExternalImageContainer, GradientImageContainer } from "./image.style";
import vodafoneCustomLoader from "../../../../../../vodafoneCustomLoader/vodafoneCustomLoader";
export var Image = function(props) {
    var ref = props || {
        nameCard: "GeneralName",
        image: ""
    }, onLoad = ref.onLoad, nameCard = ref.nameCard, image = ref.image, imageMobile = ref.imageMobile, alt = ref.alt, isMobile = ref.isMobile, style = ref.style, gradient = ref.gradient, sizes = ref.sizes, external = ref.external, width = ref.width, _objectFit = ref.objectFit, objectFit = _objectFit === void 0 ? "contain" : _objectFit;
    var ref1 = requireStaticImageAtomComponent(image || "", imageMobile, isMobile), src = ref1.src, srcSet = ref1.srcSet;
    var name = src ? src === null || src === void 0 ? void 0 : src.split("/")[src.split("/").length - 1] : src === null || src === void 0 ? void 0 : src.split("/")[src.split("/").length - 1];
    var imgStyle = _object_spread({
        objectFit: "cover",
        objectPosition: "center",
        width: "100%",
        height: "100%"
    }, style && _object_spread({}, style));
    var img = external ? /*#__PURE__*/ _jsx("div", {
        style: {
            width: "inherit",
            height: "inherit",
            position: "relative"
        },
        children: /*#__PURE__*/ _jsx(NextImage, {
            loader: vodafoneCustomLoader,
            src: image,
            alt: alt,
            style: imgStyle,
            width: width,
            quality: 100,
            layout: "fill",
            objectFit: objectFit
        })
    }) : /*#__PURE__*/ _jsx("img", {
        onLoad: onLoad,
        "data-attribute": "imgbackground-".concat(nameCard),
        alt: alt || name,
        style: imgStyle,
        srcSet: srcSet || "",
        sizes: sizes || "",
        src: src || ""
    });
    var GradientContainer = external ? GradientExternalImageContainer : GradientImageContainer;
    var containerImg = /*#__PURE__*/ _jsx(GradientContainer, {
        gradient: gradient,
        children: img
    });
    if (gradient) return containerImg;
    return img;
};
export default Image;
